import React from "react";

import { FormattedMessage, useIntl } from "react-intl";
import { Typography } from "@mui/material";
import { Button } from "../../../common/buttons";
import { CommonDialog, CommonDialogTitle, CommonDialogContent, CommonDialogActions } from "../../../common/dialogs";
import { ResponseError } from "../../../../types/common/responses/responses-types";

import "./styles.less";

type PartialApproveWarningDialogProps = {
    error?: ResponseError | null;
    open: boolean;
    onClose: () => void;
};
type ErrorsDialogContentErrorProps = {
    error: string;
};

const ErrorsDialogContentError: React.FC<ErrorsDialogContentErrorProps> = ({ error }) => {
    return (
        <Typography component="p" className="errors-dialog-message">
            {error}
        </Typography>
    );
};

const PartialApproveWarningDialog: React.FC<PartialApproveWarningDialogProps> = ({ error, open, onClose, ...props }) => {
    const intl = useIntl();

    if (!error) {
        return null;
    }

    const finalTitle = error.title || intl.formatMessage({ id: "common.error.title" });
    const detail = error.detail;

    return (
        <CommonDialog open={!!open} className="erros-dialog" {...props}>
            <CommonDialogTitle title={finalTitle} onClose={onClose} withoutCloseIcon={false} />

            <CommonDialogContent>
                <ErrorsDialogContentError error={detail} />
            </CommonDialogContent>

            <CommonDialogActions>
                <Button
                    variant="outlined"
                    onClick={onClose}
                    sx={{
                        color: "var(--font-4)",
                        borderColor: "var(--font-4)",
                    }}
                >
                    <FormattedMessage id="common.btn-close" />
                </Button>
            </CommonDialogActions>
        </CommonDialog>
    );
};

export default PartialApproveWarningDialog;
